import React from "react";
import { paymentRequest } from "../../../misc/apiRequests";
import { useTranslation } from "react-i18next";

const CheckoutPage = ({ handleLoader, handleMessagesModal, subscriptionPlanSelected,
                        setShowPaymentForm }) => {
  const { t } = useTranslation();

  const handleProceed = () => {
    const data = { ...subscriptionPlanSelected,
                   url_success: `${window.location.origin}/payment-completion`,
                   url_cancel: `${window.location.origin}/payment-completion`
                  };

    handleLoader(true);
    paymentRequest(data)
      .then(response => {
        if (response.success) {
          if (!response.record?.redirect_url) {
            handleMessagesModal('Submission Issue', 'Please ensure all information is correct.', 'error');
            handleLoader(false);
          } else {
            // Full top-level navigation: hosted payment pages block being iframed
            // (X-Frame-Options/CSP), and the gateway redirects back to url_success/url_cancel above.
            window.location.href = response.record.redirect_url;
          }
        }
        if (!response.success) {
          handleMessagesModal('Submission Issue', Array.isArray(response.errors) ? response.errors.join("\n") : response.errors, 'error');
          handleLoader(false);
        }
      });
  }

  const subscriptionMonths = subscriptionPlanSelected?.subscription?.subscription_months || 1;
  const period = `${subscriptionMonths} ${subscriptionMonths === 1 ? t('month') : t('months')}`;

  return (
    <div className="container mx-auto max-w-2xl drop-shadow-2xl">
      <div className="px-4 py-2 bg-white sm:p-6">
        <div className="mb-5">
          <h3 className="text-2xl leading-8 font-extrabold text-gray-900">
            Checkout
          </h3>
          <p className="mt-1 text-sm leading-5 text-gray-500">
            Review your order below, then proceed to complete your payment securely with Cash N&apos; Go.
          </p>
        </div>
        <div className="row g-3 mb-4">
          <div className="col-md-6" id="PlanField">
            <div className="fw-bold">Plan</div>
            <div className="text-capitalize">{subscriptionPlanSelected?.subscription?.subscription_plan}</div>
          </div>
          <div className="col-md-6" id="BillingPeriodField">
            <div className="fw-bold">Billing period</div>
            <div>{period}</div>
          </div>
          <div className="col-md-6" id="AmountField">
            <div className="fw-bold">Amount to Pay ($ BSD)</div>
            <div className="fs-4">${subscriptionPlanSelected?.subscription?.payment_amount}</div>
          </div>
        </div>
        <p className="fs-6 text-secondary-emphasis">
          You will be redirected to Cash N&apos; Go&apos;s secure payment page to complete this transaction using
          Card, CashNGo Wallet, MoneyMaxx Wallet, or Sand Dollar.
        </p>
        <div className="d-flex flex-row mt-5">
          <div className="mr-auto">
            <button
              id="BtnCancel"
              name="BtnCancel"
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowPaymentForm(false)}
            >
              {t('f_cancel') || 'Cancel Payment'}
            </button>
          </div>
          <div className="ml-auto">
            <button
              id="BtnSubmit"
              name="BtnSubmit"
              type="button"
              className="btn btn-primary"
              onClick={handleProceed}
            >
              Proceed to Secure Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheckoutPage;
